import { SplashScreen } from '@capacitor/splash-screen';

export class CapacitorSplashScreen {
  static async show() {
    await SplashScreen.show();
  }

  static async hide() {
    await SplashScreen.hide();
  }
}
